import {API_ERROR_RESET, API_ERROR_SET} from "./constants";
import {ApiErrorActions, ApiErrorState} from "./types";

const initialState: ApiErrorState = {
  error: undefined
}

const reducer = (
  state = initialState,
  action: ApiErrorActions,
): ApiErrorState => {
  switch (action.type) {
    case API_ERROR_SET:
      return {
        error: action.payload,
      };
    case API_ERROR_RESET:
      return {
        error: undefined,
      };
    default:
      return state;
  }
}

export default reducer;
